import produce from 'immer';
import objFromArray from 'src/utils/objFromArray';
import { GET_PHONE_NUMBERS } from 'src/actions/phoneNumbers';

const initialState = {
  byId: {},
  allIds: [],
};

const phoneNumbersReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_PHONE_NUMBERS: {
      const { phones } = action.payload;
      return produce(state, draft => {
        draft.byId = objFromArray(phones, 'bot_id');
        draft.allIds = Object.keys(draft.byId);
      });
    }
    default: {
      return state;
    }
  }
};

export default phoneNumbersReducer;
